import React from 'react';

// Type-cast Feather icons for React compatibility
// const FiChevronDownComponent = FiChevronDown as unknown as React.ComponentType<{
//   size?: number | string;
//   className?: string;
// }>;
// const FiChevronUpComponent = FiChevronUp as unknown as React.ComponentType<{
//   size?: number | string;
//   className?: string;
// }>;

// Interface for preview data
interface PreviewData {
  headers: string[];
  rows: any[];
  fileName: string;
}

// Props for the PreviewSection component
interface PreviewSectionProps {
  previewData: PreviewData;
  allHeadersMatch: boolean;
  handleSort: (key: string) => void;
  getSortIcon: (key: string) => React.ReactNode;
  getSortedRows: () => any[];
}

// Component for previewing imported file data
const PreviewSection: React.FC<PreviewSectionProps> = ({
  previewData,
  allHeadersMatch,
  handleSort,
  getSortIcon,
  getSortedRows,
}) => {
  return (
    <div>
      {/* File Info */}
      <div className='mb-4'>
        <h3 className='text-[18px] font-semibold text-[#3F5265]'>
          Preview: {previewData.fileName}
        </h3>
        <p className='text-[14px] text-[#657584]'>
          Showing first 10 rows of your data
        </p>
      </div>

      {/* Scrollable Table Container */}
      <div className='border border-gray-200 rounded-lg'>
        <div className='overflow-auto max-h-64'>
          <table className='min-w-full divide-y divide-gray-200'>
            <thead className='bg-gray-50 sticky top-0'>
              <tr>
                {previewData.headers.map((header, index) => (
                  <th
                    key={index}
                    className='px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100'
                    onClick={() => handleSort(header)}
                  >
                    <div className='flex items-center justify-between'>
                      <span>{header}</span>
                      <div className='flex items-center gap-1'>
                        {getSortIcon(header)}
                      </div>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className='bg-white divide-y divide-gray-200'>
              {getSortedRows().map((row, rowIndex) => (
                <tr
                  key={rowIndex}
                  className={rowIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
                >
                  {previewData.headers.map((header, cellIndex) => (
                    <td
                      key={cellIndex}
                      className='px-4 py-3 text-sm text-gray-900 max-w-xs truncate'
                    >
                      {row[header]?.toString() || ''}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Table Info */}
      <div className='mt-3 text-sm text-gray-500'>
        <p>
          Showing {Math.min(previewData.rows.length, 10)} of{' '}
          {previewData.rows.length} preview rows · {previewData.headers.length}{' '}
          columns
        </p>
      </div>


    </div>
  );
};

export default PreviewSection;